import { useEffect, useRef } from "react"

/**
 * Prefill local form state from a Convex query result. With no `sourceKey`,
 * `apply` runs once for the first non-null source (the original idiom).
 * Pass a content key of the fields you want to mirror so a later server
 * snapshot can replace a stale first paint without wiping in-progress edits
 * when those fields have not changed.
 */
export function usePrefillOnce<T>(
  source: T | null | undefined,
  apply: (source: T) => void,
  sourceKey?: string | number,
) {
  const appliedKey = useRef<string | number | true | null>(null)
  const applyRef = useRef(apply)
  applyRef.current = apply
  useEffect(() => {
    if (source == null) return
    const nextKey = sourceKey ?? true
    if (appliedKey.current === nextKey) return
    appliedKey.current = nextKey
    applyRef.current(source)
  }, [source, sourceKey])
}
